import { TextField } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import { clearBRLNumber } from '../utils/helpers/numbers';

interface Props {
  label: string;
  value: string;
  name: string;
  className?: string;
  error?: any;
  hasError?: boolean;
  disabled?: boolean;
  handleBlur?: (e: any) => void;
  handleChange?: (e: any) => void;
  sx?: any;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
}

export const InputMoney = ({
  label,
  value,
  name,
  className,
  error,
  hasError,
  handleBlur,
  handleChange,
  disabled = false,
  sx,
  fullWidth,
  size = 'small',
}: Props) => {
  return (
    <NumericFormat
      size={size}
      disabled={disabled}
      customInput={TextField}
      thousandSeparator='.'
      decimalSeparator=','
      decimalScale={2}
      allowNegative={false}
      prefix='R$ '
      label={label}
      className={className}
      error={Boolean(error)} //Ajuste para aceitar valor booleano e deixar o campo vermelho pelo yup
      helperText={error}
      name={name}
      value={value}
      onBlur={handleBlur}
      onValueChange={(values) => {
        const rawValue = clearBRLNumber(values.value);
        const fakeEvent = {
          target: {
            name,
            value: rawValue,
          },
        };
        handleChange?.(fakeEvent);
      }}
      InputLabelProps={{ shrink: true }}
      sx={{ ...sx }}
      fullWidth={fullWidth}
    />
  );
};
